import React from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import MuiDialogContent from '@mui/material/DialogContent'
import MuiDialogActions from '@mui/material/DialogActions'
import foto_tallo from '../../../../../resources/images/foto_tallo_ejemplo.png'
import { Link } from '@mui/material'
import { withStyles } from '@mui/styles'

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent)

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
    display: 'block',
  },
}))(MuiDialogActions)

export default function BulletinEventsTalloExampleDialogComponent() {
  const [open, setOpen] = React.useState(false)

  const handleClickOpen = (e) => {
    e.preventDefault()
    setOpen(true)
  }
  const handleClose = (e) => {
    e.preventDefault()
    setOpen(false)
  }

  return (
    <div>
      <Link href="#" onClick={handleClickOpen}>
        Ver ejemplo
      </Link>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        maxWidth={'md'}
      >
        <DialogContent>
          <img
            src={foto_tallo}
            style={{ width: '100%', height: 'auto' }}
            alt="Ejemplo Foto Tallo"
          />
        </DialogContent>
        <DialogActions>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Button autoFocus onClick={handleClose} color="primary">
              Cerrar
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    </div>
  )
}
